import { Icon, SkeletonBox, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { getBankLineDescription } from '@features/bankTransactions/utils/getBankLineDescription'
import { ReconciliationTransaction } from '@modules-deprecated/bankReconciliation/types'

import { ReconciliationSuggestionLine } from '../../../../../paymentReconciliationModal/elements/ReconciliationSuggestionLine'
import { BillReconciliationSuggestion } from '../BillReconciliationSuggestion'
import * as Styled from '../styles'

interface ReconciliationSuggestionProps {
  matchSuggestion?: ReconciliationTransaction
}

export const ReconciliationSuggestion = ({ matchSuggestion }: ReconciliationSuggestionProps): ReactElement => {
  const { t } = useTranslation()
  return (
    <>
      <BillReconciliationSuggestion>
        <Styled.ReconciliationSuggestionContent linePosition="right">
          <Styled.MatchIndicator>
            <Icon icon="sparkles" size="lg" color="currentColor" />
            <Space size="s6" horizontal />
            <Text variant="bodySM" weight="bold">
              {t('bill.payment_reconcile.suggestion')}
            </Text>
          </Styled.MatchIndicator>
          {matchSuggestion ? (
            <ReconciliationSuggestionLine
              title={getBankLineDescription(matchSuggestion.description)}
              amount={matchSuggestion?.amount}
              date={matchSuggestion?.bank_date}
              currency={matchSuggestion?.currency}
            />
          ) : (
            <SkeletonBox fullWidth />
          )}
        </Styled.ReconciliationSuggestionContent>
      </BillReconciliationSuggestion>
      <Space size="s16" />
    </>
  )
}
